<template>
  <div class="contract_data">
    <van-sticky>
      <van-nav-bar title="资料补齐" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-form
      label-width="140"
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group>
        <van-field
          required
          input-align="right"
          label="身份证"
          readonly
          class="data_idcard"
          :rules="[{ required: true, message: '请上传身份证图片' }]"
        >
          <template #input>
            <!-- <div>身份证</div> -->
            <div class="idcard_img">
              <van-uploader
                :max-count="1"
                v-model="uploader1"
                :after-read="afterRead1"
                fit="contain"
                :max-size="100000*1024"
              >
                <van-icon name="plus" size="30" color="#898989" />
                <div>上传正面照片</div>
              </van-uploader>
              <van-uploader
                fit="contain"
                :max-count="1"
                v-model="uploader2"
                :after-read="afterRead2"
                :max-size="100000*1024"
              >
                <van-icon name="plus" size="30" color="#898989" />
                <div>上传反面照片</div>
              </van-uploader>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          label="身份证号码"
          placeholder="请输入身份证号码"
          is-link
          v-model="submitData.idCard"
        />

        <van-field
          required
          input-align="right"
          label="营业执照"
          readonly
          class="data_idcard"
          v-model="submitData.businessLicense_fileId"
          :rules="[{ required: true, message: '请上传营业执照' }]"
        >
          <template #input>
            <div class="idcard_img">
              <van-uploader
                fit="fill"
                class="img_license"
                :max-count="1"
                v-model="uploader3"
                :after-read="afterRead3"
                :value="submitData.businessLicense_fileId"
                :max-size="100000*1024"
              >
                <van-icon name="plus" size="40" color="#898989" />
                <div>上传营业执照照片</div>
              </van-uploader>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          label="统一社会信用代码"
          placeholder="请输入统一社会信用代码"
          is-link
          v-model="submitData.unifiedSocialCreditCode"
        />

        <van-field
          required
          input-align="right"
          label="公司名称"
          placeholder="请输入公司名称"
          is-link
          v-model="submitData.company_official"
          :rules="[{ required: true, message: '请输入公司名称' }]"
        />

        <van-field
          input-align="right"
          label="法人姓名"
          placeholder="请输入法人姓名"
          is-link
          v-model="submitData.company_legalPerson"
        />

        <van-field
          required
          input-align="right"
          label="地址"
          placeholder="请输入地址"
          is-link
          v-model="submitData.company_address"
          :rules="[{ required: true, message: '请输入地址' }]"
        />
      </van-cell-group>

      <van-button color="#0CA7F0" block native-type="submit"
        >确认提交</van-button
      >
    </van-form>
  </div>
</template>

<script>
import {
  NavBar,
  Button,
  Cell,
  Image,
  Uploader,
  Icon,
  Form,
  Field,
  CellGroup,
} from "vant";
import storage from "@/utils/storage";
export default {
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      submitData: {
        id: 0,
        idCard: "",
        unifiedSocialCreditCode: "",
        company_official: "",
        company_legalPerson: "",
        company_address: "",
        idCard_front_fileId: "",
        idCard_back_fileId: "",
        businessLicense_fileId: "",
      },
      uploader1: [{ url: "" }],
      uploader2: [{ url: "" }],
      uploader3: [{ url: "" }],
    };
  },

  created() {
    this.submitData.id = this.$route.query.id;
    this.getContractDetail();
  },

  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    afterRead1(files) {
      this.uploadSingleFileApi(files, 1);
    },

    afterRead2(files) {
      this.uploadSingleFileApi(files, 2);
    },

    afterRead3(files) {
      this.uploadSingleFileApi(files, 3);
    },

    // 上传附件
    uploadSingleFileApi(files, type) {
      var that = this;
      that.$Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadSingleFile",
          fromdata,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "上传成功",
              onClose() {
                if (type === 1) {
                  that.submitData.idCard_front_fileId = res.data.data.id;
                } else if (type === 2) {
                  that.submitData.idCard_back_fileId = res.data.data.id;
                } else if (type === 3) {
                  that.submitData.businessLicense_fileId = res.data.data.id;
                }
              },
            });
          }
          console.log(res.data);
          that.$Toast.clear();
        });
    },

    onSubmit() {
      var that = this;
      if(that.submitData.idCard_front_fileId === ""){
        that.$Notify({
              type: "warning",
              message: "请上传身份证正面",
            });
        return false;
      }
      if(that.submitData.idCard_back_fileId === ""){
        that.$Notify({
              type: "warning",
              message: "请上传身份证反面",
            });
        return false;
      }
      if(that.submitData.businessLicense_fileId === ""){
        that.$Notify({
              type: "warning",
              message: "请上传营业执照",
            });
        return false;
      }
      setTimeout(function () {
        that.$api
          .orderInfoUserH5SupplementSaveAPI(that.submitData)
          .then(function (res) {
            if (res.data.code === 200) {
              that.$router.push({ path: "/order/contractFinish" });
            } else {
              that.$Notify({
                type: "danger",
                message: res.data.message,
              });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
      }, 2000);
    },

    getContractDetail() {
      let that = this
      that.$api
          .getContractDetail({
            id:that.submitData.id
          })
          .then(function (res) {
            if (res.data.code === 200) {
              that.submitData = res.data.data
              that.uploader1[0].url = res.data.data.idCard_front ? res.data.data.idCard_front : '';
              that.uploader2[0].url = res.data.data.idCard_back ? res.data.data.idCard_back : '';
              that.uploader3[0].url = res.data.data.businessLicense ? res.data.data.businessLicense : '';
              if(that.uploader1[0].url == ""){
                that.uploader1 = [];
              }
              if(that.uploader2[0].url == ""){
                that.uploader2 = [];
              }
              if(that.uploader3[0].url == ""){
                that.uploader3 = [];
              }
            } else {
              that.$Notify({
                type: "danger",
                message: res.data.message,
              });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
    },
  },
};
</script>

<style lang="less" scoped>
.contract_data {
  /deep/ .van-field__control {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    padding: 0px !important;
    margin: 0px !important;
  }

  .data_idcard {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    color: #323233;
    font-size: 14px;

    .idcard_img {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      width: 100%;

      .van-uploader {
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        width: 150px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      /deep/ .van-uploader__wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }

      /deep/ .van-uploader__preview {
        margin: 0px;
      }

      /deep/ .van-uploader__preview-image {
        width: 100%;
        height: 100%;
      }

      .img_license {
        border-radius: 2px;
        background-color: rgba(0, 0, 0, 0.02);
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }

  /deep/ .van-field__control {
    color: #979797;
  }

  .van-button {
    margin: auto;
    margin-top: 50px;
    font-size: 16px;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/contractData.vue